import React from "react";

function Card({ isNew, description, app_name, image, launch }) {
  return (
    <div className="mi-card-wrapper">
      <div className="mi-card">
        {isNew && <span className="mi-card-badge">NEW</span>}
        <div className="mi-card-image">
          <img src={image} alt={app_name} />
        </div>
        <div className="mi-card-content">
          <h6 className="mi-card-title">{app_name}</h6>
          <p className="mi-card-description">{description}</p>
        </div>
        {launch && (
          <div className="mi-card-buttons">
            <a
              href={launch}
              target="_blank"
              rel="noopener noreferrer"
              className="mi-card-btn mi-card-btn--primary"
            >
              Launch
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default Card;
